import React from 'react';
import './Loader.css'; // Import the CSS file for styling the loader

const Loader = ({ loadingPercentage, type }) => {
  const clampedPercentage = Math.min(100, Math.max(0, loadingPercentage)); // Clamp the percentage between 0 and 100
  const dashOffset = 126 - (126 * clampedPercentage) / 100;
if(type === 'document'){
  return (<div className="loader-container_doc">
      <svg className="loader-svg" width="50" height="50" viewBox="0 0 50 50">
        <circle
          className="loader-circle-bg_doc" // Add the background circle
        />
        <circle
          className="loader-circle"
          cx="25"
          cy="25"
          r="18" // Set the radius to 18
          fill="transparent"
          strokeWidth="2" // Set the stroke width to 1
          stroke="#727272"
          strokeLinecap="round"
          style={{
            strokeDasharray: `${2 * Math.PI * 18}`,
            strokeDashoffset: dashOffset,
          }}
        />
      </svg>
    </div>)
}
  return (
    <div className="loader-container">
      <svg className="loader-svg" width="50" height="50" viewBox="0 0 50 50">
        <circle
          className="loader-circle"
          cx="25"
          cy="25"
          r="20"
          fill="transparent"
          strokeWidth="5"
          stroke="#3498db"
          strokeLinecap="round"
          style={{
            strokeDasharray: '126, 126',
            strokeDashoffset: dashOffset,
          }}
        />
      </svg>
    </div>
  );
};

export default Loader;



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/AssistComponents/Loader.js